import axios from 'axios'
import BASE_URL from '../config/api.js'


const CHOICES_URL = BASE_URL + "/choices"


class ChoicesResource {
    
    getChoicesAnd(step, consumer) {
        // Return the object to possibly handle the error
        return axios.get(CHOICES_URL + "/" + step)
            .then(response => consumer(response.data.images))
    }

}

const choicesApi = new ChoicesResource()

export default choicesApi
